export enum CurrencyPosition {
  Before = 'Before',
  After = 'After'
}
